import { render, staticRenderFns } from "./base-setting.vue?vue&type=template&id=5a753793&"
import script from "./base-setting.vue?vue&type=script&lang=ts&"
export * from "./base-setting.vue?vue&type=script&lang=ts&"
import style0 from "./base-setting.vue?vue&type=style&index=0&id=5a753793&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports